import { Button, Stack, SxProps, Theme, Tooltip } from "@mui/material";
import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import CameraIcon from "@mui/icons-material/Camera";
import WhatshotIcon from "@mui/icons-material/Whatshot";
import InventoryIcon from "@mui/icons-material/Inventory";

const linkButtonSx = { fontWeight: "bold", whiteSpace: "nowrap" } as const;

export const TenantActionButtons = ({
  tenantName,
  hasHeatsDashboard,
  hasScrapReport,
  showScrapEyesIcon,
  isOpenEnabled,
  onClickCapture,
  sx,
}: {
  tenantName: string;
  hasHeatsDashboard: boolean;
  hasScrapReport: boolean;
  showScrapEyesIcon: boolean;
  isOpenEnabled: boolean;
  onClickCapture?: (e: React.MouseEvent) => void;
  sx?: SxProps<Theme>;
}) => {
  const { t } = useTranslation();

  const disabledTooltip = t("scrapChefNotInstalled");

  return (
    <Stack direction="row" gap={0.5} alignItems="flex-end" sx={sx}>
      <Stack alignItems="flex-end">
        {showScrapEyesIcon ? (
          <Button
            size="small"
            disableRipple
            endIcon={<CameraIcon fontSize="small" />}
            sx={{ ...linkButtonSx, cursor: "default", color: "primary.main" }}
          >
            {t("scrapEye")}
          </Button>
        ) : null}
        {hasHeatsDashboard && isOpenEnabled ? (
          <Button
            component={Link}
            to={`/${tenantName}/dashboard/heats`}
            color="secondary"
            onClick={onClickCapture}
            size="small"
            endIcon={<WhatshotIcon fontSize="small" />}
            sx={linkButtonSx}
          >
            {t("heats")}
          </Button>
        ) : null}
        {hasScrapReport && isOpenEnabled ? (
          <Button
            component={Link}
            to={`?tab=scrapReports&tenant=${tenantName}`}
            color="secondary"
            onClick={onClickCapture}
            size="small"
            endIcon={<InventoryIcon fontSize="small" />}
            sx={linkButtonSx}
          >
            {t("scrapReport")}
          </Button>
        ) : null}
      </Stack>
      <Tooltip title={isOpenEnabled ? "" : disabledTooltip}>
        <span>
          <Button
            {...(isOpenEnabled
              ? { component: Link, to: `/${tenantName}` }
              : {})}
            variant="contained"
            color="warning"
            onClick={onClickCapture}
            sx={{ fontWeight: "bold" }}
            disabled={!isOpenEnabled}
          >
            {t("openLink")}
          </Button>
        </span>
      </Tooltip>
    </Stack>
  );
};
